import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { BrowserView, MobileView } from 'react-device-detect';
import { connect } from 'react-redux';

import { Route, Switch } from './fixRoutes';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login/Login';
import MonthlyResult from './components/Report/MonthlyResult';
import Results from './components/Instagram/Results';
import PeriodResult from './components/Instagram/PeriodResult';
import InstagramResult from './components/Instagram/InstagramResult';
import BillingIntro from './components/Billing/BillingIntro';
import BillingPage from './components/Billing/BillingPage';
import MethodAdded from './components/Billing/MethodAdded';
import AddCard from './components/Billing/AddCard';
import AddBankAccount from './components/Billing/AddBankAccount';
import DesktopPage from './components/Billing/DesktopPage';
import MainReport from './components/Report/MainReport';
import MobileWarning from './components/MobileWarning';
import OneTimeToken from './components/OneTimeToken';
import BillingToken from './components/BillingToken';
import Dashboard from './components/Dashboard';
import MobileDashboard from './components/MobileDashboard';
import Profile from './components/Profile/Profile';
import WorkingHoursEditor from './components/Profile/WorkingHoursEditor';
import CreateOffer from './components/Offers/Create/CreateOffer';
import OfferShipment from './components/Offers/OfferShipment';
import Offers from './components/Offers/Offers';
import OfferSubmitted from './components/Offers/Create/OfferSubmitted';
import CallSheetSubmitted from './components/Offers/Partials/CallSheetSubmitted';
import ErrorReporter from './ErrorReporter';
import ApplyOffer from './components/Offers/Apply/ApplyOffer';
import ApplyOfferApplicant from './components/Offers/Apply/ApplyOfferApplicant';
import ExportApplicants from './components/Offers/Apply/ExportApplicants';
import AddCallSheet from './components/Offers/Partials/AddCallSheet';
import NotFound from "./components/NotFound";
import * as applyOffersActions from './redux/applyOffers';
import './App.css';

interface Props {
  fetchMappings: Function;
}

// prettier-ignore
class App extends React.Component<Props> {

  componentDidMount() {

    this.props.fetchMappings();
  }

  render() {
    return (
      <div>
        <ErrorReporter>
          <BrowserView key="browser">
            <Router>
              <Switch>
                <Route exact path="/login" component={Login} />
                <Route exact path="/report/:id" component={(m: any) => <MainReport id={m.match.params.id} />} />
                <Route exact path="/static/:id" component={(m: any) => <MainReport id={m.match.params.id} />} />
                <Route exact path="/token/monthly" component={(m) => <OneTimeToken redirect="monthly"/>} />
                <Route exact path="/token/:token" component={(m: any) => <OneTimeToken token={m.match.params.token} />} />
                <Route exact path="/token/" component={(m) => <OneTimeToken/>} />
                <ProtectedRoute exact path="/" component={Dashboard} />
                <ProtectedRoute exact path="/billing" component={() => <DesktopPage child="intro" />} />
                <ProtectedRoute exact path="/billing/card" component={() => <DesktopPage child="card" />} />
                <ProtectedRoute exact path="/billing/account" component={AddBankAccount} />
                <ProtectedRoute exact path="/billing/methods" component={() => <DesktopPage child="methods" />} />
                <ProtectedRoute exact path="/billing/added" component={() => <DesktopPage child="methods" popup={true} />} />
                <ProtectedRoute exact path="/billing/error" component={() => <DesktopPage child="error" />} />
                <ProtectedRoute exact path="/results" component={MonthlyResult} />
                <ProtectedRoute exact path="/offers/create" component={CreateOffer} />
                <ProtectedRoute exact path="/offers/submitted" component={OfferSubmitted} />
                <ProtectedRoute exact path="/offers/active" component={() => <Offers type="active" />} />
                <ProtectedRoute exact path="/offers/upcoming" component={() => <Offers type="upcoming" />} />
                <ProtectedRoute exact path="/offers/past" component={() => <Offers type="past" />} />
                <ProtectedRoute exact path="/offers/:id/shipment" component={OfferShipment} />
                <ProtectedRoute exact path="/offers/:id/callSheet/" component={AddCallSheet} />
                <ProtectedRoute exact path="/offers/:id/callSheet/submitted" component={CallSheetSubmitted} />
                <ProtectedRoute exact path="/offer/apply/:offerId" component={ApplyOffer} />
                <ProtectedRoute exact path="/offer/apply/:offerId/applicant/:applicantId" component={ApplyOfferApplicant} />
                <ProtectedRoute exact path="/offer/apply/export/:offerId/:filter" component={ExportApplicants} />
                <ProtectedRoute exact path="/profile" component={Profile} />
                <ProtectedRoute exact path="/profile" component={() => <Profile edit={false} />} />
                <ProtectedRoute exaxt path="/profile/edit" component={() => <Profile edit={true} />} />
                <ProtectedRoute exact path="/profile/hours" component={WorkingHoursEditor} />
                <Route component={NotFound} />
              </Switch>
            </Router>
          </BrowserView>
          <MobileView key="mobile">
            <Router>
              <Switch>
                <Route exact path="/login" component={Login} />
                <ProtectedRoute exact path="/" component={MobileDashboard} />
                <ProtectedRoute exact path="/instagram/view/:id" component={(m: any) => <InstagramResult id={m.match.params.id} />} />
                <ProtectedRoute exact path="/instagram/:period" component={(m: any) => <PeriodResult period={m.match.params.period} />} />
                <ProtectedRoute exact path="/instagram" component={Results} />
                <ProtectedRoute exact path="/billing" component={BillingIntro} />
                <ProtectedRoute exact path="/billing/card" component={AddCard} />
                <ProtectedRoute exact path="/billing/methods" component={BillingPage} />
                <ProtectedRoute exact path="/billing/added" component={MethodAdded} />
                <ProtectedRoute exact path="/billing/account" component={AddBankAccount} />
                <Route exact path="/billing/login/" component={(m: any) => <BillingToken token={m.location.search.substring(5)} />} />
                <ProtectedRoute component={MobileWarning} />
              </Switch>
            </Router>
          </MobileView>
        </ErrorReporter>
      </div>
    );
  }
}

const mapStateToProps = ({ applyOffers }) => ({ applyOffers });

export default connect(mapStateToProps, applyOffersActions)(App);
